<div class="modal-shell">
  <div class="modal-header-row">
    <div>
      <h2 class="modal-title">Forgot Password</h2>
      <p class="modal-subtitle">
        Enter your username and complete captcha to receive OTP.
      </p>
    </div>
    <button type="button" class="close-btn" (click)="dissmissModal()" aria-label="Close">
      <i class="fa fa-times" aria-hidden="true"></i>
    </button>
  </div>

  <form [formGroup]="forgotpassForm" (ngSubmit)="onSubmit()" class="modal-form">
    <div class="form-field">
      <label for="username">Username</label>
      <input
        id="username"
        type="text"
        autocomplete="off"
        formControlName="username"
        class="form-control"
        maxlength="20"
        [class.is-invalid]="forgotpassForm.get('username')?.invalid && forgotpassForm.get('username')?.touched"
        placeholder="Enter username" />
      <div class="error-message" *ngIf="forgotpassForm.get('username')?.invalid && forgotpassForm.get('username')?.touched">
        {{ getErrorMessage('username') }}
      </div>
    </div>

    <div class="captcha-container">
      <label for="captchaInput" class="captcha-label">Captcha</label>
      <div class="captcha-background" [style.backgroundImage]="'url(' + noiseImage + ')'">
        <div *ngFor="let captcha of captchaText" [ngStyle]="captcha.style" class="captcha-character">
          {{ captcha.char }}
        </div>
        <button type="button" class="refresh-button" (click)="refreshCaptcha($event)">
          <i class="fa fa-refresh"></i>
        </button>
      </div>

      <div class="captcha-input">
        <input
          id="captchaInput"
          type="text"
          placeholder="Enter Captcha"
          formControlName="captcha"
          (input)="validateCaptcha($any($event.target).value)"
          maxlength="8"
          (paste)="onPaste($event)"
          class="captcha-text-input" />
        <div class="captcha-status">
          <span *ngIf="forgotpassForm.get('captcha')?.value && validCaptcha" class="valid-status">OK</span>
          <span *ngIf="forgotpassForm.get('captcha')?.value && !validCaptcha" class="invalid-status">X</span>
        </div>
      </div>
    </div>

    <div class="error-message" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

    <div class="action-row">
      <button type="button" class="btn-secondary" (click)="dissmissModal()" [disabled]="isSubmitting">
        Cancel
      </button>
      <button type="submit" class="btn-primary" [disabled]="forgotpassForm.invalid || !validCaptcha || isSubmitting">
        {{ isSubmitting ? "Sending..." : "Send OTP" }}
      </button>
    </div>
  </form>
</div>
